import { Connection } from "../State/Routine/types";
import { useRoutineEditDirty_Routine$data } from "./__generated__/useRoutineEditDirty_Routine.graphql";

export function connectionDirtyCheck(
  remoteConnections: useRoutineEditDirty_Routine$data["activeVersion"]["connections"],
  currentConnections: Connection[] | undefined,
  remoteTasks: useRoutineEditDirty_Routine$data["activeVersion"]["tasks"]
) {
  if (currentConnections === undefined) {
    return false;
  }
  for (const localConnection of currentConnections) {
    const remoteConnection = remoteConnections.find(
      ({ sectionId, taskId }) =>
        sectionId === localConnection.sectionId &&
        taskId === localConnection.taskId
    );

    const originalTask = remoteTasks.find(
      ({ id }) => id === localConnection.taskId
    );
    const originalGoal =
      originalTask?.__typename === "TaskNumber"
        ? originalTask.goals?.find(
            ({ section }) => section.id === localConnection.sectionId
          )
        : null;

    const remoteValue =
      originalGoal?.lessThan ?? originalGoal?.greaterThan ?? 0;

    if (
      !remoteConnection ||
      localConnection.ordinal !== remoteConnection.ordinal ||
      localConnection.value !== remoteValue ||
      (localConnection.orgTopic?.id ?? null) !==
        (remoteConnection.orgTopic?.id ?? null) ||
      (localConnection.canBeDisabled ?? false) !==
        (remoteConnection.canBeDisabled ?? false)
    ) {
      return true;
    }
  }

  for (const remoteConnection of remoteConnections) {
    const localConnection = currentConnections.find(
      ({ sectionId, taskId }) =>
        sectionId === remoteConnection.sectionId &&
        taskId === remoteConnection.taskId
    );
    if (!localConnection) {
      return true;
    }
  }
  return false;
}
